<template>
  <v-row justify="center" v-if="filterconsolidado.length != 0">
    <v-dialog v-model="dialog" scrollable max-width="320px" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn plain v-bind="attrs" v-on="on">
          <v-icon>mdi-chevron-down</v-icon>
          <span :class="['font-weight-bold']">({{ codArt }})</span>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar color="primary" dark dense height="28">
          <v-container>
            <v-layout row>
              <span :class="['font-weight-bold', 'body-2', 'mx-auto']"
                >Resultado de Articulos
              </span>
            </v-layout>
          </v-container>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              dialog = false;
              searchArt = '';
            "
            plain
          >
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-toolbar>
        <v-text-field
          v-model="searchArt"
          autofocus
          placeholder="Escriba el Codigo del Articulo"
          v-if="filterconsolidado.length != 0"
          filled
          dense
          prepend-inner-icon="mdi-keyboard-outline"
          color="primary"
        ></v-text-field>

        <v-virtual-scroll
          :bench="benched"
          :items="filterBy"
          height="400"
          item-height="60"
        >
          <template v-slot:default="{ item }">
            <v-list-item
              :key="item.Codigo"
              @click="otroArt(item.Codigo)"
              :disabled="item.Codigo === codArt"
            >
              <v-avatar tile size="50">
                <imgPredet :withImg="50" :codart="item.Codigo" :urlimg="imgSrc(item.Codigo)" :key="updateImg" />

               
              </v-avatar>

              <v-list-item-content>
                <strong>{{ `Ref: ${item.Codigo} ` }} </strong>
                <v-list-item-title v-html="item.Nombre"> </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
          </template>
        </v-virtual-scroll>

        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import imgPredet from "../components/ImgPred";
export default {
  props: {
    codArt: String,
  },
  components: {
    imgPredet,
   
  },
  methods: {
    ...mapMutations(["CLR_DATOS_ART"]),
    ...mapActions(["cargarDatosPromo", "cargarFeature", "cargarDatosArt"]),
    ChrEsp(chr) {
      const chrSplit = chr.split("");
      let newChr = "";

      chrSplit.forEach((x) => {
        if (x === "/") newChr += "-";
        else if (x === ".") newChr += "-";
        else newChr += x;
      });

      return newChr;
    },
    otroArt(codart) {

      window.scrollTo(0, 0);
      //this.CLR_PROMO();
      // codart = codart.replaceAll("/", "-");
      let xCodart = encodeURIComponent(codart);
      this.$router.push({
        path: "/articulo/" + xCodart,
      });
      //this.$router.push({ path: `/articulo/${codart}` }).catch((err) => {});


      this.cargarDatosPromo({ codart: codart });
      this.cargarDatosArt({ codart: codart });

      this.cargarFeature({
        articulo: codart,
        cia: 1,
        opc: 8,
      });
      this.CLR_DATOS_ART();
    },

    imgArt(id) {
      let urlImg = null;

      let nb = this.filterconsolidado
        .filter((x) => x.Codigo === id)
        .map((x) => x.Imagen);
      urlImg = `${this.imgPeque}${nb.toString()}`;

      return urlImg;
    },
  },
  computed: {
    ...mapState(["imgPeque", "NoImg", "domoapi2_img",]),
    ...mapGetters(["filterconsolidado"]),
    imgSrc: function () {
      return function (cod) {
        let xSrc = this.domoapi2_img;
      xSrc += "Articulo/";
      xSrc += this.ChrEsp(cod);
      xSrc += "/Principal?";
      xSrc += "Cia=15";
      return xSrc;
      };
    },

    filterBy() {
      let arrAll = this.filterconsolidado.filter(
        (x) =>
          x.Codigo.toLowerCase().includes(this.searchArt) ||
          x.Nombre.toLowerCase().includes(this.searchArt)
      );
      return arrAll;
    },
  },
  data() {
    return {
      dialogm1: "",
      dialog: false,
      benched: 0,
      searchArt: "",
      updateImg: Math.floor(Math.random() * 100),
    };
  },
};
</script>

<style></style>
